export const DEFAULT_FLEX_CENTER = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 1,
}

export const FLEX_COL_CENTER = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 1,
}

export const FLEX_COL_JUSTIFY_CENTER = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: 1,
}

export const DEFAULT_CONTAINER_COL_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxSizing: 'border-box',
}

export const DEFAULT_CONTAINER_ROW_STYLE = {
  display: 'flex',
  alignItems: 'center',
}

export const FLEX_COL_SPACE_BETWEEN = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}

export const FLEX_ROW_SPACE_BETWEEN = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}

export const LOADER_OVERLAY_STYLE = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  zIndex: 2,
} as const

export const SOMETHING_WRONG_MSG =
  'Something went wrong. Please try again later.'
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY'
export const DEFAULT_DATE_RANGE_FORMAT = 'YYYY/MM/DD'
export const DEFAULT_TIME_FORMAT = 'HH:mm:ss'
export const DEFAULT_DATE_TIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`
export const API_DATE_TIME_FORMAT = 'YYYYMMDD'
export const NO_ACCESS_ERR_MSG =
  "You don't have access to view. Please connect with your Manager / IT department to get the access."
